import { NutrimaticError } from '@nutrimatic/sdk'

export function nutrimaticErrorMessage(error: unknown): string {
  if (error instanceof NutrimaticError) {
    return `${error.code}: ${error.message}`
  }
  if (error instanceof Error) return error.message
  return String(error)
}

export function isNutrimaticInfrastructureError(error: unknown): boolean {
  return error instanceof NutrimaticError && error.code === 'INFRASTRUCTURE_UNAVAILABLE'
}
